// /PaymentGateway.jsx
import React, { useState } from "react";
import "./PaymentGateway.css";
import config from "./config";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const { apiBaseUrl } = config;

const PaymentGateway = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { userDetails } = location.state || {};

  const [isLoading, setIsLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);

  const amount = userDetails.amount;
  // const amount = 1;
  const clientData = userDetails;
  console.log(clientData);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const addClient = async () => {
    if (userDetails) {
      try {
        const response = await axios.post(
          `${apiBaseUrl}client/add-client`,
          userDetails,
          {
            headers: {
              "x-api-key": "tendtomend2023", // 👈 your API key here
              "Content-Type": "application/json", // optional, good to have
            },
          }
        );
        console.log("Client added successfully:", response.data);
      } catch (error) {
        console.error("Error Adding client ", error);
      }
    }
  };

  const handlePayment = async () => {
    const isScriptLoaded = await loadRazorpayScript();
    if (!isScriptLoaded) {
      alert("Failed to load Razorpay SDK. Please try again later.");
      return;
    }

    try {
      setIsLoading(true);
      // Create Razorpay order
      const { data } = await axios.post(
        `${apiBaseUrl}razorpay/create-order`,

        {
          amount,
        }
      );

      const { order } = data;

      console.log(order.id);

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount: amount * 100,
        currency: "INR",
        name: "Tend to Mend Counselling",
        description: "Payment for counselling session",
        order_id: order.id,
        prefill: {
          name: userDetails.name,
          email: userDetails.email,
          contact: userDetails.mobile,
        },
        theme: {
          color: "#4e361f",
        },

        modal: {
          ondismiss: function () {
            if (paymentStatus !== "success") {
              navigate("/");
            }
          },
        },

        handler: async (response) => {
          try {
            const confirmResponse = await axios.post(
              `${apiBaseUrl}payment/complete-payment`,
              {
                paymentId: response.razorpay_payment_id,
                orderId: response.razorpay_order_id,
                signature: response.razorpay_signature,
                clientData: {
                  name: clientData.name,
                  mobile: clientData.mobile,
                  email: clientData.email,
                  bookingDate: clientData.bookingDate,
                  bookingTimeSlot: clientData.bookingTimeSlot,
                  address: clientData.address,
                  checkedItems: clientData.checkedItems,
                  amountPaid: clientData.amount,
                },
              },
              {
                headers: {
                  "x-api-key": "tendtomend2023",
                  "Content-Type": "application/json",
                },
              }
            );

            console.log(confirmResponse.status);
            console.log("Payment successful, attempting navigation..."); // Debug log

            if (confirmResponse.status === 200) {
              setPaymentStatus("success");
              addClient();
              navigate("/");
              alert(
                "Payment successful! A confirmation email has been sent to you."
              );
            } else {
              setPaymentStatus("failure");
              alert(
                "Payment confirmed but email could not be sent. Please contact support."
              );
            }
          } catch (error) {
            setPaymentStatus("failure");
            alert(
              "An error occurred while confirming the payment. Please try again."
            );
          } finally {
            setIsLoading(false);
          }
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      alert("Failed to initiate payment.");
      setIsLoading(false); // Stop loading
    }
  };
  if (isLoading) {
    return (
      <div className="captcha-whole-div">
        <div className="qr-page-main-div">
          <h2 className="payment-below-payment-text">Processing Payment</h2>
          <p className="captcha-www-text text-center">
            Please wait while we process your payment. Do not refresh or close
            this window.
          </p>

          <div className="loading-animation">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="captcha-whole-div">
      <div className="qr-page-main-div">
        <h2 className="payment-below-payment-text">Payment Details</h2>
        <p className="captcha-www-text">
          Please review your details and proceed to payment.
        </p>

        <div className="qrpage-scan-bank">
          {/* User Information */}
          <div className="qr-img-div">
            <p className="qr-page-accountdetail-text">User Information</p>
            <p className="qrpage-account-texts">
              <strong>Name:</strong> {userDetails.name}
            </p>
            <p className="qrpage-account-texts">
              <strong>Parent/Guardian:</strong> {userDetails.parent}
            </p>
            <p className="qrpage-account-texts">
              <strong>Email:</strong> {userDetails.email}
            </p>
            <p className="qrpage-account-texts">
              <strong>Phone:</strong> {userDetails.mobile}
            </p>
            <p className="qrpage-account-texts">
              <strong>Address:</strong> {userDetails.address}
            </p>
            <p className="qrpage-account-texts">
              <strong>Session Type:</strong> {userDetails.sessionType}
            </p>
            <p className="qrpage-account-texts">
              <strong>Amount:</strong> {userDetails.amount}
            </p>
          </div>

          {/* Session Selection */}
          {/* <div className="qrpage-session-detail">
            <p className="qr-page-accountdetail-text">Select Session Type</p>
            <select
              className="qrpage-session-dropdown"
              value={sessionType}
              onChange={(e) => setSessionType(e.target.value)}
            >
              <option value="individual">Individual Counselling - ₹1200</option>
              <option value="couple">Couple Counselling - ₹1500</option>
            </select>
          </div> */}

          {/* Amount to Pay */}
          {/* <div className="qrpage-bank-detail">
            <p className="qr-page-accountdetail-text">Amount to Pay</p>
            <p className="qrpage-account-texts">
              <strong>₹{amount}/-</strong>
            </p>
          </div> */}
        </div>

        <button className="qr-home-button mt-2" onClick={handlePayment}>
          Proceed to Pay
        </button>
      </div>
    </div>
  );
};

export default PaymentGateway;
